
class WildbirdVariantTracker {
  constructor() {
    this.init();
  }

  init() {
    this.setVariables()
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.bindEvents();
      });
    } else {
      this.bindEvents();
    }
  }

  bindEvents() {
    if(this.productForms.length) {
      this.productForms.forEach(form=>{
        form.addEventListener("change", this.onFormVariantChangeHandle)
      })
    }
    
  }

  setVariables(){
    this.productForms = document.querySelectorAll("form[action='/cart/add'][preorder-type='variant']");
    this.onFormVariantChangeHandle = this.onFormVariantChange.bind(this);
  }

  onFormVariantChange(event){
    const form = event.target.closest("form");
    if(!form) return;
    this.setProperties(form);
    this.setMessageVisibility(form);
    
  }

  setProperties(form) {
    const selectEl = form.querySelector("[data-product-select]");

    const preOrderPropertyEls = form.querySelectorAll("[data-preorder-properties] input");
    
    if(preOrderPropertyEls.length) {
      preOrderPropertyEls.forEach(input => {
        const isCurrent = input.getAttribute("data-variant") == selectEl.value;
        if(isCurrent) {
          input.removeAttribute("disabled");
        } else {
          input.setAttribute("disabled", "disabled");
        }
      });
    }
  }

  setMessageVisibility(form) {
    const selectEl = form.querySelector("[data-product-select]");
    const preOrderMessageEls = form.querySelectorAll("[data-preorder-message]");
    if(preOrderMessageEls.length) {
      preOrderMessageEls.forEach(p => {
        const isCurrent = p.getAttribute("data-variant") == selectEl.value;
        if(isCurrent) {
          p.classList.remove("hidden");
        } else {
          p.classList.add("hidden");
        }
      });
    }
  }


}

document.addEventListener('DOMContentLoaded', () => {
  window.wildbirdVariantTracker = new WildbirdVariantTracker();
});

if (document.readyState !== 'loading') {
  window.wildbirdVariantTracker = new WildbirdVariantTracker();
}
